import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { SERVICES, WHY, waLink } from "../../lib/data";

export const Services = () => (
  <>
    <section id="layanan" className="py-24 md:py-32 bg-[#F5F7FA]">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="max-w-2xl">
          <Reveal><Overline>Layanan</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-heading font-bold text-[#111827] text-4xl md:text-5xl tracking-tight">
              Layanan & Solusi Teknologi
            </h2>
          </Reveal>
        </div>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-12 gap-5">
          {SERVICES.map((s, i) => (
            <Reveal key={s.no} delay={(i % 3) * 0.08} className={s.span}>
              <a
                href={waLink(s.wa)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`service-card-${s.no}`}
                className="group relative flex flex-col h-full min-h-[300px] rounded-2xl overflow-hidden border border-gray-100 bg-white shadow-sm hover:shadow-2xl transition-all duration-300"
              >
                <div className="relative h-40 overflow-hidden">
                  <img
                    src={s.img}
                    alt={`${s.title} - SATCOM Rangkasbitung`}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#071A33]/70 to-transparent" />
                  <span className="absolute top-4 left-4 grid place-items-center h-11 w-11 rounded-xl bg-white/90 backdrop-blur text-[#0B63F6]">
                    <s.icon className="h-5 w-5" />
                  </span>
                  <span className="absolute top-4 right-4 font-heading font-extrabold text-white/90 text-lg">
                    {s.no}
                  </span>
                </div>
                <div className="flex flex-col flex-1 p-6">
                  <span className="text-xs uppercase tracking-[0.2em] font-semibold text-[#0B63F6]">{s.tag}</span>
                  <h3 className="mt-2 font-heading font-bold text-xl text-[#111827]">{s.title}</h3>
                  <p className="mt-2 text-sm text-[#6B7280] leading-relaxed flex-1">{s.desc}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-[#0B63F6] group-hover:gap-2.5 transition-all">
                    {s.cta}
                    <ArrowUpRight className="h-4 w-4" />
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

    {/* Why Us */}
    <section className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="max-w-2xl">
          <Reveal><Overline>Kenapa SATCOM?</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-heading font-bold text-[#111827] text-4xl md:text-5xl tracking-tight">
              Mengapa Memilih SATCOM MEDIA TEKNOLOGI?
            </h2>
          </Reveal>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {WHY.map((w, i) => (
            <Reveal key={w.title} delay={(i % 3) * 0.08}>
              <div
                data-testid={`why-card-${i}`}
                className="group h-full rounded-2xl border border-gray-100 p-7 hover:border-[#0B63F6]/30 hover:bg-[#F5F7FA]/60 transition-all duration-300"
              >
                <span className="grid place-items-center h-12 w-12 rounded-xl bg-gradient-to-br from-[#0B63F6] to-[#16C7E8] text-white shadow-lg shadow-[#0B63F6]/25">
                  <w.icon className="h-6 w-6" />
                </span>
                <h3 className="mt-4 font-heading font-bold text-lg text-[#111827]">{w.title}</h3>
                <p className="mt-1.5 text-sm text-[#6B7280] leading-relaxed">{w.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  </>
);
